import {
	type SxProps,
	TextField,
	type TextFieldProps,
	type Theme,
} from "@mui/material";
import {
	type Control,
	Controller,
	type FieldPath,
	type FieldValues,
} from "react-hook-form";

export const disableNumberArrowsSx: SxProps<Theme> = {
	"& input[type=number]::-webkit-inner-spin-button, & input[type=number]::-webkit-outer-spin-button":
		{
			WebkitAppearance: "none",
			margin: 0,
		},
	"& input[type=number]": {
		MozAppearance: "textfield",
	},
};

type Props<T extends FieldValues> = {
	control: Control<T>;
	name: FieldPath<T>;
	disableNumberArrows?: boolean;
} & Omit<TextFieldProps, "value" | "error" | "helperText" | "name">;

export const FormTextField = <T extends FieldValues>({
	name,
	control,
	disableNumberArrows,
	sx,
	onChange,
	...textFieldProps
}: Props<T>) => (
	<Controller
		control={control}
		name={name}
		render={({ field, fieldState }) => (
			<TextField
				{...textFieldProps}
				{...field}
				sx={{
					...(disableNumberArrows && disableNumberArrowsSx),
					...sx,
				}}
				onChange={(e) => {
					field.onChange(e);
					onChange?.(e);
				}}
				value={field.value ?? ""}
				error={!!fieldState.error?.message}
				helperText={fieldState.error?.message}
			/>
		)}
	/>
);
